
<template>
  <a-layout-content class="wemail-sites-overview">
    <a-breadcrumb :style="{ marginBottom: '20px' }">
      <a-breadcrumb-item>
        <router-link tag="a" :to="{ name: 'sites.index' }">Sites</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>{{ this.$route.meta.title }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="wemail-tabs-wrap">
      <SitesNavigation/>
      <div class="wemail-overview-content">
        <SiteDetails/>
        <a-divider />
        <SiteStats/>
        <a-divider />
        <ListsGrowth/>
        <a-divider />
        <OpenVSClickVSBounce/>
      </div>
    </div>
  </a-layout-content>
</template>
<script>
import SitesNavigation from "@/components/SitesNavigation.vue";
import OpenVSClickVSBounce from "@/components/Sites/overview/OpenVSClickVSBounce.vue";
import SiteStats from "@/components/Sites/overview/SiteStats.vue";
import ListsGrowth from "../../components/Sites/overview/ListsGrowth";
import SiteDetails from "../../components/Sites/overview/SiteDetails";

export default {
  data() {
    return {
      loading: true
    }
  },
  components: {
    SiteDetails,
    ListsGrowth,
    SitesNavigation,
    OpenVSClickVSBounce,
    SiteStats
  },
  methods: {

  },
};
</script>

